import GenericDB from './generic-db';

export default class MessagesDB extends GenericDB {
  constructor() {
    super('messages');
  }
}
